<div class="performance-table">
  <h3>{{ title || 'Performance Table' }}</h3>
  <div class="table-container">
    <table class="performance-table">
      <thead>
        <tr>
          <th *ngFor="let column of columns">{{ column.header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td *ngFor="let column of columns"
              [class]="column.className"
              [style.color]="getScoreColor(getNestedValue(row, column.scoreKey || column.key))">
            {{ getNestedValue(row, column.key) || 'N/A' }}
            <span *ngIf="column.key === 'name' && row.is_your_brand" class="your-brand-badge">YOU</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
